<template>
  <b-modal
    v-model="modalStatus"
    centered
    size="xl"
    button-size="sm"
    no-close-on-backdrop
  >
    <template #modal-header>
      <h5 class="modal-title">Last Addresses</h5>
      <button type="button" class="close" @click="closeModal()">×</button>
    </template>
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>
    <div>
      <div class="pool-container">
        <dx-data-grid
          :data-source="lastAddedPoolData"
          :ref="dataGridLastData"
          id="lastAddedDataGrid"
          class="meilisearch-datagrid-pool"
          :show-borders="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-min-width="50"
          columnResizingMode="widget"
          :showColumnLines="true"
          :showRowLines="true"
          :no-data-text="$t('general.noEntries')"
          :column-auto-width="true"
          :word-wrap-enabled="true"
          :hover-state-enabled="true"
          @toolbar-preparing="onToolbarPreparing"
          @contentReady="contentReady"
        >
          <dx-scrolling
            mode="virtual"
            row-rendering-mode="virtual"
          />
          <dx-filter-row
            :visible="true"
            apply-filter=""
          />
          <dx-column
            :caption="$t('recherche.search.id')"
            data-field="id"
            data-type="number"
            :width="100"
            cell-template="link-to-crm-template"
            :editor-options="{ showClearButton: true }"
          />
          <dx-column
            :caption="$t('recherche.detail.company')"
            data-field="company"
            :calculate-cell-value="tempDevCompany"
            :editor-options="{ showClearButton: true }"
          />
          <dx-column
            :caption="$t('recherche.detail.firstname')"
            data-field="firstName"
            :editor-options="{ showClearButton: true }"
          />
          <dx-column
            :caption="$t('recherche.detail.lastname')"
            data-field="lastName"
            :editor-options="{ showClearButton: true }"
          />
          <template #link-to-crm-template="{ data }">
            <a v-if="data.data.id && data.data.crmProfiles.length" :href="data.data.crmProfiles.find( el => el.profiltypId === 2 ) ? `https://crm.ifj.ch/index.cfm?&page=137659&crm_adresse_id=${data.data.id}`: `https://crm.ifj.ch/index.cfm?&page=137767&crm_adresse_id=${data.data.id}`" target="_blank">{{data.data.id}}</a>
            <a v-else :href="`https://crm.ifj.ch/index.cfm?&page=117525&ADDRESSESID=${data.data.id}`" target="_blank">{{data.data.id}}</a>
          </template>
          <template #totalGroupCount>
            <div class="informer" v-if="totalCount > 0">
              <span class="count">{{ filteredCount }} results out of {{ totalCount }} records</span>
            </div>
          </template>
        </dx-data-grid>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          hidden
        >
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import {
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxFilterRow
  } from 'devextreme-vue/data-grid'

  const dataGridLastData = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxScrolling,
      DxColumn,
      DxFilterRow
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        dataGridLastData,
        totalCount: 0,
        filteredCount: 0
      }
    },
    created () {
      if (this.totalCount === 0) {
        this.totalCount = this.lastAddedPoolData.length
      }
    },
    methods: {
      contentReady (e) {
        this.filteredCount = this.dataGrid.totalCount()
      },
      tempDevCompany (rowData) {
        return rowData.company ? rowData.company.replaceAll('(DEV)', '') : rowData.company
      },
      closeModal () {
        this.$store.commit('recherche/SET_LAST_ADDED_ADDRESSES_STATUS', false)
      },
      onToolbarPreparing (e) {
        e.toolbarOptions.items.unshift({
          location: 'before',
          template: 'totalGroupCount'
        })
      }
    },
    computed: {
      ...mapGetters({
        lastAddedPoolData: 'recherche/LAST_ADDED_POOLDATA'
      }),
      ...mapState({
        modalStatus: state => state.recherche.modalLastAddressesStatus
      }),
      dataGrid: function () {
        return this.$refs[dataGridLastData].instance
      }
    }
  }
</script>

<style lang="scss">
#lastAddedDataGrid {
    height: 50vh;
    margin-bottom: 0;
}
</style>
